import { Link } from 'react-router-dom';
import SafariMultiDay from './assets/SafariMult.jpg';

function MultiDaySafariPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage multi-day-safari-hero">
        <div className="hero-content">
          <h1>Ebamba's Multi-Day Safari Adventures</h1>
          <p>Immerse yourself deeply in the wilderness with extended safari experiences.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">The Ultimate African Bush Experience</h2>
          <div className="content-intro">
            <img src={SafariMultiDay} alt="Multi-Day Safari" className="tour-main-image" />
            <p>For the ultimate African adventure, Ebamba Travel & Tours offers bespoke multi-day safaris that take you further into the wild and allow for a truly comprehensive wildlife experience. From 2 nights to a week or more, these extended journeys allow you to explore different ecosystems, track elusive animals, and fully absorb the tranquility and excitement of the bush.</p>
            <p>Tailored to your interests and budget, our multi-day safaris can combine various game reserves, cultural interactions, and even specific wildlife photography opportunities. Enjoy multiple game drives, guided walks, and the luxury of time to witness the intricate drama of the African wilderness unfold.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Multi-Day Safari</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-sun"></i>
              <h4>Extensive Game Viewing</h4>
              <p>Multiple daily game drives across different times of day for maximum wildlife observation, including rare sightings.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-bed"></i>
              <h4>Diverse Accommodation</h4>
              <p>Options ranging from rustic tented camps to luxurious 5-star lodges, often with breathtaking views.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-map-marked-alt"></i>
              <h4>Exploration of Multiple Regions</h4>
              <p>Opportunity to visit different game reserves or areas, offering varied landscapes and animal populations.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-walking"></i>
              <h4>Specialized Activities</h4>
              <p>Includes guided bush walks, bird watching, night drives, and cultural visits (depending on reserve).</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Explorers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Our 4-day safari arranged by Ebamba was truly the trip of a lifetime! We saw everything, and the lodge was magnificent. Every detail was perfect."</p>
              <span>– Karen J. from USA</span>
            </div>
            <div className="testimonial-card">
              <p>"The multi-day safari allowed us to slow down and truly appreciate the magic of the bush. Our guide was phenomenal. Huge thanks to Ebamba for an unforgettable adventure."</p>
              <span>– Oliver P. from UK</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Design Your Multi-Day Safari</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MultiDaySafariPage;
